"undefined" == typeof Shopify.Cart && (Shopify.Cart = {});
(function($) { 
  "use strict";
  Shopify.Cart.getCartPage = function() {
		$.ajax({
			url: Shopify.root_url+'/cart?view=page-ajax',
			type: 'GET'
		})
		.done(function(data) {
			// console.log("success");
			data = data.split('<!-- summary-discounts -->');
			$('#cart-form').html(data[0]);
			if (data[1].length > 0){
				$('.summary-discounts').html(data[1]).removeClass('d-none');
			} else {
				$('.summary-discounts').html(data[1]).addClass('d-none');
			}
			$('#cart-form').removeClass('loading');
		})
		.fail(function() {
			console.log("error get cart");
	    location.reload();
		})
		.always(function() {
			// console.log("complete");
		});
  }
	// QA 23 Oct 2026: a quantity box saves ONLY its own line (/cart/change.js by line key). Over stock,
	// the box goes back to the real quantity with "Only N available" under it, instead of the old
	// alert + reload that looked like a silent revert. Other fields (note, gift wrap) still use update.js.
	function lineError($input, xhr) {
		var n = {};
		try { n = JSON.parse(xhr.responseText) || {}; } catch (e) {}
		var text = n.description || n.message || '';
		var m = /only\s+(?:add\s+)?(\d+)/i.exec(text);
		var msg = m ? 'Only ' + m[1] + ' available' : (text || "Sorry, we couldn't update your basket. Please try again.");
		$.getJSON(Shopify.root_url + '/cart.js', function(cart) {
			$.each(cart.items, function(i, it) { if (it.key === $input.attr('data-key')) { $input.val(it.quantity); return false; } });
		}).always(function() {
			$('#cart-form').removeClass('loading');
			var $cell = $input.closest('td');
			$cell.find('.gdc-line-error').remove();
			$('<p class="gdc-line-error" role="alert"></p>').text(msg).css({ margin: '6px 0 0', color: '#b42318', fontSize: '0.875rem', fontWeight: 500 }).appendTo($cell.length ? $cell : $input.parent());
		});
	}
	$(document).on('change', '#cart-form', function(event) {
		event.preventDefault();
		var $target = $(event.target);
		var lineKey = $target.is('input.input-qty[data-key]') ? $target.attr('data-key') : null;
		$(this).find('.gdc-line-error').remove();
		$(this).addClass('loading');
		var data = $(this).serialize();
		var qty = parseInt($target.val(), 10);
		if (!(qty >= 0)) qty = 0;
		$.ajax(lineKey ? {
			url: Shopify.root_url+'/cart/change.js',
			type: 'POST',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify({ id: lineKey, quantity: qty })
		} : {
			url: Shopify.root_url+'/cart/update.js',
			type: 'POST',
			dataType: 'json',
			data: data,
		})
		.done(function(cart) {
			// console.log("success");
			if (cart.item_count > 0) {				
				Shopify.Cart.getCartPage()
			  $('.cartCount').text(cart.item_count);
			  $('.cartCost').attr('data-price',cart.total_price).html(theme.Currency.formatMoney(cart.original_total_price, theme.moneyFormat));
			  var shipp = parseFloat($('.content__shipping').find('input[type="radio"][checked="checked"]').val()) * 100 || 0;
			  $('.cartCostTotal').html(theme.Currency.formatMoney(cart.total_price+shipp, theme.moneyFormat));			  
	      if($('.spendFreeShip').length > 0){
	        var $spendFreeShip = $('.spendFreeShip');
	        var line_total = parseInt($spendFreeShip.find('[aria-valuemax]').attr('aria-valuemax'));
	        var progress_bar = $spendFreeShip.find('.progress-bar');
	        if (line_total > cart.total_price){
	          progress_bar.attr('aria-valuenow', line_total - cart.total_price).css('width',cart.total_price / line_total * 100 + '%').text(Math.round(cart.total_price / line_total * 100) + '%');
	          $spendFreeShip.find('.text_progress span:first-child').html(theme.function.threshold_cart.replace('#more', theme.Currency.formatMoney(line_total - cart.total_price, theme.moneyFormat)));
	          $spendFreeShip.removeClass('congratulations');
	        }else{
	          progress_bar.attr('aria-valuenow', line_total).css('width','100%').text('100%');
	          $spendFreeShip.addClass('congratulations');
	        }
	      }
			} else {
				$('.cart-has-content').remove()
				$('.cart-empty-content').removeClass('d-none')
			}
		})
		.fail(function(xhr) {
			if (lineKey) { lineError($target, xhr); return; }
			$('#cart-form').removeClass('loading');
			if (Shopify.KT_notice) Shopify.KT_notice({ text: "Sorry, we couldn't update your basket. Please try again." });
		})
		.always(function(cart) {
			if ($('#address_country').length > 0) {
		    if($('#address_country option').length <= 0 ) {
		      Shopify.Cart.getCountry();
		    }
		    if($('.get__shipping').attr('data-curr-address') !== undefined && cart && cart.item_count > 0){
		      $('.get__shipping').show();
		      if ($('#address_country option').length > 0) {
		        var address = JSON.parse($('.get__shipping').attr('data-curr-address'));
		        Shopify.Cart.getCartShippingRates(address,Shopify.Cart.getShippingCart,Shopify.Cart.onError);
		      }
		    }
		  }
			// console.log("complete");
		});		
	});
	$(document).on('click', 'a.btn-remove', function(event) {
		event.preventDefault();
		$(this).parents('tr').find('.input-qty').val(0).trigger('change')
	});
})( jQuery );